var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthsideimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18.667,
    viewBox: "0 0 24 18.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M3,6.333A1.333,1.333,0,0,1,4.333,5H25.667a1.333,1.333,0,0,1,0,2.667H4.333A1.333,1.333,0,0,1,3,6.333Zm0,8A1.333,1.333,0,0,1,4.333,13H17.667a1.333,1.333,0,0,1,0,2.667H4.333A1.333,1.333,0,0,1,3,14.333Zm0,8A1.333,1.333,0,0,1,4.333,21H11a1.333,1.333,0,1,1,0,2.667H4.333A1.333,1.333,0,0,1,3,22.333Z",
    transform: "translate(-3 -5)",
    fill: "#15345a",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthsideimg);
export default __webpack_public_path__ + "static/media/healthsideimg.7a684f18518bd51c4c5a17ea8dd45c9f.svg";
export { ForwardRef as ReactComponent };